import { createFileRoute } from '@tanstack/react-router';
import { AdminTailgateCostPalletPage } from '@/features/admin/admin-tailgate-cost-pallet-page';

export const Route = createFileRoute('/admin/tailgate-cost-pallet')({
  component: AdminTailgateCostPalletRoute,
});

function AdminTailgateCostPalletRoute() {
  return <AdminTailgateCostPalletPage />;
}
